// The store's follow-up after each command (DocStore.deriver): the pipes rebuild when a fitting or a pipe end moves, and
// (3.20.0) the walls rebuild when their spine or their doors change. Both run on the drawing as the command left it and
// touch different objects; their follow-ups go in one step, so one undo puts all of it back.
import type { Doc } from "./entities";
import type { Command } from "./commands";
import { pipeDeriver } from "../pipes/api";
import { wallDeriver } from "../walls/wall";

export function deriveAll(doc: Doc, cmd: Command): Command | null {
  const pipes = pipeDeriver(doc, cmd);
  const walls = wallDeriver(doc, cmd);
  if (pipes && walls) return { kind: "batch", label: "follow-up", commands: [pipes, walls] };
  return pipes ?? walls;
}
